import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Server, Smartphone, RefreshCw } from 'lucide-react';

interface LoginFormProps {
  phoneNumber: string;
  otpCode: string;
  showOtpSection: boolean;
  isLoading: boolean;
  onLogin: (e: React.FormEvent) => void;
  onOTPVerification: (e: React.FormEvent) => void;
  onPhoneNumberChange: (value: string) => void;
  onOtpCodeChange: (value: string) => void;
  onBackToPhone: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  phoneNumber,
  otpCode,
  showOtpSection,
  isLoading,
  onLogin,
  onOTPVerification,
  onPhoneNumberChange,
  onOtpCodeChange,
  onBackToPhone
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-purple-700 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white/95 backdrop-blur-lg border-white/20 shadow-2xl">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Server className="h-12 w-12 text-blue-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-800">LGP</CardTitle>
          <CardDescription>Masuk dengan OTP WhatsApp</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {!showOtpSection ? (
            <form onSubmit={onLogin} className="space-y-4">
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700 flex items-center">
                  <Smartphone className="h-4 w-4 mr-2 text-green-500" />
                  Nomor WhatsApp
                </label>
                <Input
                  type="tel"
                  placeholder="628123456789"
                  value={phoneNumber}
                  onChange={(e) => onPhoneNumberChange(e.target.value)}
                  required
                />
                <p className="text-xs text-gray-500">Masukkan nomor WhatsApp admin</p>
              </div>
              <Button type="submit" className="w-full" disabled={isLoading}>
                {isLoading && <RefreshCw className="h-4 w-4 mr-2 animate-spin" />}
                Kirim OTP
              </Button>
            </form>
          ) : (
            <div className="space-y-4">
              <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-green-800">
                      OTP dikirim ke WhatsApp
                    </p>
                    <p className="text-xs text-green-600">
                      {phoneNumber.replace(/(\d{3})(\d*)(\d{4})/, '$1****$3')}
                    </p>
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={onBackToPhone}
                    className="text-green-700 border-green-300 hover:bg-green-100"
                  >
                    Ubah No
                  </Button>
                </div>
              </div>
              <form onSubmit={onOTPVerification} className="space-y-4">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Kode OTP</label>
                  <Input
                    type="text"
                    placeholder="123456"
                    maxLength={6}
                    value={otpCode}
                    onChange={(e) => onOtpCodeChange(e.target.value)}
                    className="text-center text-lg tracking-widest"
                    required
                  />
                  <p className="text-xs text-gray-500">Cek WhatsApp Anda untuk kode OTP</p>
                </div>
                <Button type="submit" className="w-full" disabled={isLoading}>
                  {isLoading && <RefreshCw className="h-4 w-4 mr-2 animate-spin" />}
                  Verifikasi & Masuk
                </Button>
              </form>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginForm;